// extracted by mini-css-extract-plugin
export var drawerPaper = "_2i-0";
export var itemCard = "_2i-1";
export var itemImage = "_2i-2";